"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MediaCredits = _interopRequireDefault(require("../MediaCredits"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Image = /*#__PURE__*/function (_Component) {
  _inherits(Image, _Component);

  var _super = _createSuper(Image);

  function Image(props) {
    var _this;

    _classCallCheck(this, Image);

    _this = _super.call(this, props);
    _this.parseHtml = _this.parseHtml.bind(_assertThisInitialized(_this));
    _this.remapHtmlStructure = _this.remapHtmlStructure.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Image, [{
    key: "parseHtml",
    value: function parseHtml(htmlString) {
      if (htmlString && htmlString.length) {
        var parser = new window.DOMParser();
        var xmlDoc = parser.parseFromString(htmlString, 'text/html');
        return xmlDoc;
      }
    } // The entire point of this function is to give us a similar structure to a slideshow
    // slide. It wraps the image and paragraph(s) with <div class="HwInfo"></div>

  }, {
    key: "remapHtmlStructure",
    value: function remapHtmlStructure(html) {
      var serializer = new window.XMLSerializer();
      var dom = this.parseHtml(html);
      var imgContainers = dom.querySelectorAll('.HwImageWrapper');
      var section = dom.querySelector('.HwSection');
      var wrapper = document.createElement('div');
      wrapper.setAttribute('class', 'HwInfo'); // find the first image wrapper and insert the wrapper div before it

      imgContainers[0].parentNode.insertBefore(wrapper, imgContainers[0]); // move the image wrapper(s) into it

      for (var i = 0; i < imgContainers.length; i++) {
        wrapper.appendChild(imgContainers[i]);
      } // move the section (with paragraphs) into it


      wrapper.appendChild(section);
      return serializer.serializeToString(dom);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          item = _this$props.item,
          hideDisclaimer = _this$props.hideDisclaimer;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.remapHtmlStructure(item.html)
        }
      }), /*#__PURE__*/_react.default.createElement(_MediaCredits.default, {
        hideDisclaimer: hideDisclaimer,
        asOfDate: item.certifiedDate,
        legal: item.legal,
        credits: item.credits
      }));
    }
  }]);

  return Image;
}(_react.Component);

Image.defaultProps = {
  hideDisclaimer: false
};
Image.propTypes = {
  item: _propTypes.default.object,
  hideDisclaimer: _propTypes.default.bool
};
var _default = Image;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/content/MediaGallery/Image.js